export const LayoutSize = {
  Half: 'Half',
  Full: 'Full',
} as const;
